import React, { useContext, useEffect, useState } from "react";
import { Form, Input, Button } from "antd";
import styled from "styled-components";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { registerAPI } from "../api/authAPI";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  margin: 0 auto;
  width: 60vw;
  height: 85vh;
  padding: 20px;
  display: flex;
  align-items: center;
`;

const FormContainer = styled.div`
  margin: 0 auto;
  width: 50vw;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #ddd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const FormTitle = styled.h1`
  text-align: center;
  margin-bottom: 20px;
`;

const FormButtonWrapper = styled.div`
  margin-top: 50px;
  display: flex;
  justify-content: center;
`;

const StyledInput = styled(Input)`
  width: 100%;
`;

const InputContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const RegistrationPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));

  const navigate = useNavigate();

  const handleSubmit = async () => {
    await registerAPI({
      username,
      password,
      firstName,
      lastName,
    });
  };

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user, navigate]);

  return (
    <Container>
      <FormContainer>
        <FormTitle>Registration</FormTitle>
        <Form onFinish={handleSubmit}>
          <Form.Item
            name="username"
            rules={[{ required: true, message: "Please enter your username" }]}
          >
            <StyledInput
              prefix={<UserOutlined />}
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </Form.Item>
          <Form.Item
            name="name"
            rules={[{ required: true, message: "Please enter your name" }]}
          >
            <InputContainer>
              <StyledInput
                prefix={<UserOutlined />}
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              <StyledInput
                prefix={<UserOutlined />}
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </InputContainer>
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please enter your password" }]}
          >
            <StyledInput.Password
              prefix={<LockOutlined />}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            dependencies={["password"]}
            rules={[
              { required: true, message: "Please confirm your password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("The two passwords do not match")
                  );
                },
              }),
            ]}
          >
            <StyledInput.Password
              prefix={<LockOutlined />}
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </Form.Item>
          <Form.Item>
            <FormButtonWrapper>
              <Button type="primary" htmlType="submit">
                Register
              </Button>
            </FormButtonWrapper>
          </Form.Item>
        </Form>
      </FormContainer>
    </Container>
  );
};

export default RegistrationPage;
